import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import {
  RequestsPermissions,
  RequestType,
  RequestTypeTranslation
} from 'src/app/shared/model/requestType.enum';
import { User } from 'src/app/shared/model/user.model';
import { HandlePermissions } from 'src/app/shared/utils/permissions';
import { environment } from 'src/environments/environment';
@Component({
  standalone: true,
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    CardComponent,
    RouterModule,
    I18NextModule,
    MatButtonModule
  ]
})
export class MenuComponent implements OnInit, AfterViewInit {
  requestTypesEnum = Object.values(RequestType);
  requestTypesTranslationsEnum = Object.values(RequestTypeTranslation);
  requestPermissionsEnum = Object.values(RequestsPermissions);
  user!: User;

  requestTypes: any = [];
  //transfers = false;

  constructor(
    private navigationService: NavigationService,
    private storageService: StorageService,
    public permissions: HandlePermissions
  ) {}

  ngOnInit(): void {
    //this.transfers = this.storageService.get('transfers') || false;
    this.storageService.set('requestCarType', null);
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
      if (environment.env !== 'prod') {
        this.user.category = 'MK';
        this.user.groupType = '';
      }
    }
    this.filterRequestTypes();
  }
  filterRequestTypes() {
    this.requestTypes = this.requestPermissionsEnum
      .filter(
        (reqType) =>
          reqType !== RequestsPermissions.dotArr &&
          reqType !== RequestsPermissions.provisional &&
          reqType !== RequestsPermissions.vo
      )
      .map((reqType) => {
        return {
          value: reqType,
          name: this.translateRequestType(reqType)
        };
      });

    /*if (!this.transfers) {
        this.requestTypes = this.requestTypes.filter((reqType: any) => reqType.value !== RequestsPermissions.transfers);
      }*/
  }

  translateRequestType(reqType: RequestsPermissions): any {
    let reqTypeTranslation = '';
    switch (reqType) {
      case RequestsPermissions.dotArr: {
        reqTypeTranslation = i18next.t('dotArr');
        break;
      }
      case RequestsPermissions.didactic: {
        reqTypeTranslation = i18next.t('didactic');
        break;
      }
      case RequestsPermissions.function: {
        reqTypeTranslation = i18next.t('function');
        break;
      }
      case RequestsPermissions.generalServices: {
        reqTypeTranslation = i18next.t('generalServices');
        break;
      }
      case RequestsPermissions.innerRoute: {
        reqTypeTranslation = i18next.t('innerRoute');
        break;
      }
      case RequestsPermissions.judgements: {
        reqTypeTranslation = i18next.t('judgements');
        break;
      }
      case RequestsPermissions.loanLongTerms ||
        RequestsPermissions.loanCarPool ||
        RequestsPermissions.loanWedding: {
        reqTypeTranslation = i18next.t('loan');
        break;
      }
      case RequestsPermissions.provisional: {
        reqTypeTranslation = i18next.t('provisional');
        break;
      }
      case RequestsPermissions.proyect: {
        reqTypeTranslation = i18next.t('proyect');
        break;
      }
      case RequestsPermissions.transfers: {
        reqTypeTranslation = i18next.t('transfers');
        break;
      }
      case RequestsPermissions.redPlates: {
        reqTypeTranslation = i18next.t('redPlate');
        break;
      }
      case RequestsPermissions.es: {
        reqTypeTranslation = i18next.t('es');
        break;
      }
    }

    return reqTypeTranslation;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('menu');
    }, 0);
  }
}
